<script setup lang="ts">
import type { FormKitFrameworkContext } from '@formkit/core'
import Checkbox from 'primevue/checkbox'

const props = defineProps<{
  context: FormKitFrameworkContext
}>()

async function onUpdated(value: boolean) {
  await props.context.node.input(value)
}
</script>

<template>
  <Checkbox
    :input-id="context.id"
    :model-value="context._value"
    :binary="true"
    @update:model-value="onUpdated"
  />
</template>
